<template>
  <VExpansionPanel data-test="featuresSelectionPanel">
    <ValidationObserver
      ref="featuresSelection"
      v-slot="{ valid, validated }"
      name="featuresSelection"
    >
      <VExpansionPanelHeader
        v-blur
        class="body-1"
        disableIconRotate
        hideActions
      >
        <template #default="{ open }">
          <VRow class="d-flex align-items-center">
            <VIcon
              class="pr-2"
              :color="(!valid && validated) ? 'error' : ''"
            >
              mdi-tune
            </VIcon>
            {{ amountSelectedFeatures !== 1
              ? $t('bookingForm.features', { amountFeatures: amountSelectedFeatures })
              : $t('bookingForm.feature', { amountFeatures: amountSelectedFeatures })
            }}
            <VSpacer />
            <VIcon :class="open ? 'arrow-rotate' : ''">
              {{ 'mdi-chevron-down' }}
            </VIcon>
          </VRow>
        </template>
      </VExpansionPanelHeader>
      <VExpansionPanelContent
        eager
        data-test="featuresSelectionPanelContent"
      >
        <SFeatures
          :currentLang="currentLang"
          :features="selectedFeatures"
          :animalsTransportation="animalsTransportation"
          :rideType="rideType"
          :appConfig="appConfig"
          :passengersAmount="passengersAmount"
          @setFeatureAmount="setFeatureAmount"
          @setAnimalsTransportation="setAnimalsTransportation"
        />
      </VExpansionPanelContent>
    </ValidationObserver>
  </VExpansionPanel>
</template>
<script lang="ts">
export default {
  name: 'SFeaturesSelection',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import SFeatures from '@slg/web-customer-shared/src/components/common/features/SFeatures.vue';

const props = defineProps({
  currentLang: {
    type: String,
    default: 'en',
  },
  isValidAmountOfPassenger: {
    type: Boolean,
    default: true,
  },
  vehicleCategoryId: {
    type: String,
    default: null,
  },
  selectedFeatures: {
    type: Array,
    default: () => [],
  },
  animalsTransportation: {
    type: Boolean,
    default: false,
  },
  passengersAmount: {
    type: Number,
    default: null,
  },
  rideType: {
    type: String,
    default: null,
  },
  appConfig: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['setFeatureAmount', 'setAnimalsTransportation']);

const amountSelectedFeatures = computed(() => {
  const selectedFeatures = props.selectedFeatures.reduce((acccomulator, item) => {
    return item.amount + acccomulator;
  }, 0);
  return props.animalsTransportation ? selectedFeatures + 1 : selectedFeatures;
});

function setFeatureAmount(feature) {
  emit('setFeatureAmount', feature);
}

function setAnimalsTransportation(animalsTransportation) {
  emit('setAnimalsTransportation', animalsTransportation);
}
</script>
<style lang="scss" scoped>
</style>
